import { GoblinPlayer } from './MusicPlayerElements';
import Music from '../../music/music.mp3'

function MusicPlayer() {
    return (
        <GoblinPlayer src={Music} autoplay loop controls />
    );
}

export default MusicPlayer; 